import { BehaviorSubject } from "rxjs";
import { captureError } from "./sentry";

export const globalError$ = new BehaviorSubject<Error | null>(null);

export function reportGlobalError(err: unknown): void {
  const error = err instanceof Error ? err : new Error(String(err));
  console.error("[globalError]", error);
  captureError(error);
  if (globalError$.value) return;
  globalError$.next(error);
}

export function installGlobalErrorHandlers(): void {
  window.addEventListener("error", (e) => {
    reportGlobalError(e.error ?? e.message);
  });
  window.addEventListener("unhandledrejection", (e) => {
    reportGlobalError(e.reason);
  });
}
